export default {"src":"/_next/static/media/mark.75daf2bd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};